import { useLocale } from "@/i18n/LocaleProvider";
import { LocalizedText } from "@/i18n/LocalizedText";
import { CircleMinus, CircleSlash2 } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { useSidebar } from "./ui/sidebar";
import { type Table } from "@tanstack/react-table";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";

const PromptsActive = ({
  rowSelection,
  table,
  handler,
  customAction,
  handlePrompClusterChange,
  options,
  selectedOption,
}: {
  rowSelection: any;
  table: Table<any>;
  handler: any;
  handlePrompClusterChange: (value: string) => void;
  customAction?: any;
  options: any;
  selectedOption: any;
}) => {
  const { t } = useLocale();
  const { state } = useSidebar();
  return (
    <div
      style={{
        width:
          window.innerWidth >= 768
            ? `calc(100vw - ${state === "collapsed" ? "80" : "240"}px)`
            : "100%",
        left:
          window.innerWidth >= 768
            ? `${state === "collapsed" ? "80" : "240"}px`
            : "0",
      }}
      className={`border-t flex justify-center fixed transition-all duration-300 bottom-0 bg-white w-full md:w-auto`}
    >
      <div
        className={`${Object.keys(rowSelection).length > 0 ? "flex my-2" : "hidden"} border-[#898989] gap-2 w-fit bg-[#171717] text-[#FAFAFA] p-2 items-center rounded-lg justify-center`}
      >
        <div className="flex  w-fit items-center border border-[#898989] rounded-lg">
          <span className="mx-2 text-xs font-normal">
            {Object.keys(rowSelection).length} selected
          </span>
          <Separator
            orientation="vertical"
            className="bg-[#898989] data-[orientation=vertical]:h-[20px]"
          ></Separator>
          <Button
            disabled={table.getSelectedRowModel().rows.length === 0}
            onClick={() => table.resetRowSelection()}
            className="w-fit cursor-pointer has-[>svg]:px-2"
          >
            <CircleMinus size={16} />
          </Button>
        </div>
        <Separator
          orientation="vertical"
          className="bg-[#898989] data-[orientation=vertical]:h-[30px]"
        ></Separator>
        {selectedOption && selectedOption !== "all-clusters" && (
          <Select
            value="Assign Cluster"
            onValueChange={(value) => {
              handlePrompClusterChange(value);
            }}
          >
            <SelectTrigger
              className="border-[#898989] text-[#0A0A0A] flex w-40 **:data-[slot=select-value]:block **:data-[slot=select-value]:text-white **:data-[slot=select-value]:truncate @[767px]/card:hidden"
              size="default"
              aria-label={t("legacy.select.a.value.nv8d47")}
            >
              <div className="text-white">
                <LocalizedText id="legacy.assign.cluster.1p6keem" />
              </div>
            </SelectTrigger>
            <SelectContent className="rounded-xl">
              {options?.map((cluster: { id: string; title: string }) => {
                return (
                  <SelectItem value={cluster.id} className="rounded-lg">
                    {cluster.title}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        )}
        <button
          className="flex justify-center"
          onClick={() => handler(false, table)}
        >
          <div
            className={`text-xs gap-2 flex px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${table.getSelectedRowModel().rows.length === 0 && "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50"}`}
          >
            {customAction ? (
              <>
                {customAction.icon} {customAction.title}
              </>
            ) : (
              <>
                {" "}
                <CircleSlash2 size={16} />{" "}
                <LocalizedText id="legacy.deactivate.vwcdnh" />
              </>
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

export default PromptsActive;
